<form [formGroup]="aboutFg" #form="ngForm">

    <section>
        <div class="group-section">
            <h1 class="mat-headline-large">About your vehicle loan</h1>
        </div>
        <div class="group-section small-group">
            <p class="mat-body-large">What type of vehicle are you looking to purchase?</p>
            <div class="group-required">
                <mat-button-toggle-group class="button-group"
                    aria-label="What type of vehicle are you looking to purchase?"
                    [formControl]="aboutFg.controls.purchaseVehicleType" [hideSingleSelectionIndicator]="true">
                    <mat-button-toggle value="{{VehicleClass.PassengerVehicle}}">Passenger / Van /
                        Ute</mat-button-toggle>
                    <mat-button-toggle value="{{VehicleClass.Motorcycle}}">Motorcycle</mat-button-toggle>
                    <mat-button-toggle value="{{VehicleClass.Caravan}}">Motorhome</mat-button-toggle>
                    <mat-button-toggle value="{{VehicleClass.Motorhome}}">Caravan</mat-button-toggle>
                    <!-- <mat-button-toggle value="{{VehicleClass.Boat}}">Marine</mat-button-toggle> -->
                    <mat-button-toggle value="{{VehicleClass.GoodsVehicle}}">Truck</mat-button-toggle>
                </mat-button-toggle-group>
                <mat-error *ngIf="form.submitted && aboutFg.controls.purchaseVehicleType.hasError('required')">
                    Please select a vehicle type.
                </mat-error>
            </div>
        </div>

        <div class="group-section">
            <app-form-button-group-simple [formSubmitted]="form.submitted" [control]="aboutFg.controls.hasVehicle"
                label="Do you have a specific vehicle in mind?"
                errorPlaceholder="Please tell us whether you have a specific vehicle in mind.">
            </app-form-button-group-simple>
        </div>


        <div class="group-section" *ngIf="aboutFg.controls.hasVehiclePlateVin.enabled">
            <app-form-button-group-simple [formSubmitted]="form.submitted"
                [control]="aboutFg.controls.hasVehiclePlateVin"
                label="Do you know the plate number or VIN of the vehicle?">
            </app-form-button-group-simple>
        </div>

        <ng-container *ngIf="aboutFg.controls.hasVehicle.value == UserAction.Yes">
            <ng-container *ngIf="aboutFg.controls.hasVehiclePlateVin.value == UserAction.Yes">
                <div class="group-section">
                    <app-vehicle-lookup [formSubmitted]="form.submitted" label="Plate No or VIN"
                        [control]="aboutFg.controls.vehiclePlateVin"
                        [parentControl]="aboutFg.controls.hasVehiclePlateVin"
                        (vehicleSelected)="purchaseVehicleSelected($event)">
                    </app-vehicle-lookup>
                </div>
            </ng-container>

            <ng-container *ngIf="aboutFg.controls.hasVehiclePlateVin.value == UserAction.No">
                <div class="group-section small-group">
                    <app-form-field-numeric [formSubmitted]="form.submitted" label="Vehicle year"
                        [control]="aboutFg.controls.vehicleYear">
                    </app-form-field-numeric>

                    <app-form-field [formSubmitted]="form.submitted" label="Vehicle make"
                        [control]="aboutFg.controls.vehicleMake">
                    </app-form-field>

                    <app-form-field [formSubmitted]="form.submitted" label="Vehicle model"
                        [control]="aboutFg.controls.vehicleModel">
                    </app-form-field>
                </div>
            </ng-container>

            <div class="group-section">
                <app-form-button-group-simple [formSubmitted]="form.submitted"
                    [control]="aboutFg.controls.vehicleIsBrandNew" label="Is it new or used?" yesLabel="New"
                    noLabel="Used">
                </app-form-button-group-simple>
            </div>


        </ng-container>
        <!-- 
        <div class="group-section">
            <app-form-button-group-simple [formSubmitted]="form.submitted"
                [control]="aboutFg.controls.isBusinessPurpose"
                label="Do you intend to use this vehicle for business purposes?">
            </app-form-button-group-simple>
        </div> -->

        @if(aboutFg.controls.hasVehicle.value == UserAction.Yes){
        <div class="group-section small-group">
            <mat-label>What is your vehicle cost?</mat-label>
            <app-form-field-currency [formSubmitted]="form.submitted" label="Vehicle cost"
                [control]="aboutFg.controls.vehiclePrice" hint="Please include GST, registration & licensing"
                [decimal_precision]="2">
            </app-form-field-currency>
        </div>
        }
        @else {
        <div class="group-section small-group">
            <mat-label>What is your vehicle budget?</mat-label>
            <app-form-field-currency [formSubmitted]="form.submitted" label="Vehicle budget"
                [control]="aboutFg.controls.loanAmount" hint="Please include GST, registration & licensing"
                [decimal_precision]="0">
            </app-form-field-currency>
        </div>
        }

        <div class="group-section small-group">
            <app-form-button-group-simple [formSubmitted]="form.submitted" [control]="aboutFg.controls.hasOtherItems"
                label="Will you be purchasing any additional items?" hint="This includes insurances, accessories etc.">
            </app-form-button-group-simple>
        </div>

        <ng-container *ngIf="aboutFg.controls.hasOtherItems.value == UserAction.Yes">
            <!-- Accessories Section -->
            <section>
                <hr class="separator" />
                <div class="group-section title-section">
                    <h1 class="mat-headline-large">Accessories</h1>
                </div>

                <div class="section-spacing">
                    <ng-container *ngFor="let accessory of aboutFg.controls.extras.controls; let i = index">
                        <div class="group-section small-group">
                            <div class="row">
                                <div class="col-12">
                                    <div class="flex-content height-24">
                                        <p class="mat-body-large">Accessory {{i+1}}</p>
                                        <button mat-button class="link-button no-background-link remove" type="button"
                                            (click)="removeAccessory(i)"><mat-icon
                                                svgIcon="trash"></mat-icon>Remove</button>
                                    </div>
                                </div>
                            </div>
                            <div class="group-section">
                                <app-form-field-select label="Type" [control]="accessory.controls.type"
                                    [listType]="SelectListType.AccessoryTypes">
                                </app-form-field-select>
                                <app-form-field [formSubmitted]="form.submitted" label="Description"
                                    *ngIf="accessory.controls.type.value == ExtraExtraTypeEnum.Other"
                                    [control]="accessory.controls.description">
                                </app-form-field>
                                <app-form-field-currency [formSubmitted]="form.submitted" label="Price"
                                    [control]="accessory.controls.price" [decimal_precision]="2">
                                </app-form-field-currency>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="aboutFg.controls.extras.controls.length < 5" class="height-24">
                        <button mat-button class="link-button no-background-link" (click)="addAccessory()"
                            type="button"><mat-icon svgIcon="add"></mat-icon>Add accessory</button>
                    </div>
                </div>
            </section>

            <!-- Insurances Section -->
            <section>
                <hr class="separator" />
                <div class="group-section title-section">
                    <h1 class="mat-headline-large">Insurances</h1>
                </div>

                <div class="section-spacing">
                    <ng-container *ngFor="let insurance of aboutFg.controls.insurances.controls; let i = index">
                        <div class="group-section small-group">
                            <div class="row">
                                <div class="col-12">
                                    <div class="flex-content height-24">
                                        <p class="mat-body-large">Insurance {{i+1}}</p>
                                        <button mat-button class="link-button no-background-link remove" type="button"
                                            (click)="removeInsurance(i)"><mat-icon
                                                svgIcon="trash"></mat-icon>Remove</button>
                                    </div>
                                </div>
                            </div>
                            <div class="group-section">
                                <app-form-field-select label="Type" [control]="insurance.controls.type"
                                    [listType]="SelectListType.InsuranceTypes"
                                    [disabledOptions]="getSelectedInsuranceTypes(i)">
                                </app-form-field-select>
                                <app-form-field-currency [formSubmitted]="form.submitted" label="Price"
                                    [control]="insurance.controls.price" [decimal_precision]="2">
                                </app-form-field-currency>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="aboutFg.controls.insurances.controls.length < 3" class="height-24">
                        <button mat-button class="link-button no-background-link" (click)="addInsurance()"
                            type="button"><mat-icon svgIcon="add"></mat-icon>Add insurance</button>
                    </div>
                </div>
            </section>
        </ng-container>
    </section>
    <hr class="separator" />
    <section>
        <div class="group-section">
            <h1 class="mat-headline-large">Cash deposit / trade in</h1>
        </div>
        <div class="group-section">
            <app-form-button-group-simple [formSubmitted]="form.submitted" [control]="aboutFg.controls.hasDeposit"
                label="Do you have a cash deposit?">
            </app-form-button-group-simple>
        </div>
        <div class="group-section"
            *ngIf="aboutFg.controls[ApplicationFormControlNames.HasDeposit].value == UserAction.Yes">
            <app-form-field-currency [formSubmitted]="form.submitted" label="Cash deposit value"
                [control]="aboutFg.controls.depositAmount" [decimal_precision]="0">
            </app-form-field-currency>
        </div>

        <div class="group-section">
            <app-form-button-group-simple [formSubmitted]="form.submitted"
                [control]="aboutFg.controls.hasTradeInVehicle" label="Do you have a trade in vehicle?">
            </app-form-button-group-simple>
        </div>
        <ng-container *ngIf="aboutFg.controls.hasTradeInVehicle.value == UserAction.Yes">
            <div class="group-section">
                <app-vehicle-lookup [formSubmitted]="form.submitted" label="Plate No or VIN"
                    [control]="aboutFg.controls.tradeInVehicle.controls.plate"
                    [parentControl]="aboutFg.controls.hasTradeInVehicle"
                    (vehicleSelected)="tradeinVehicleSelected($event)">
                </app-vehicle-lookup>
            </div>

            <div class="group-section">
                <app-form-field-currency [formSubmitted]="form.submitted" label="Estimated trade in value"
                    [control]="aboutFg.controls.tradeInVehicle.controls.price" [decimal_precision]="0">
                </app-form-field-currency>
            </div>

            <div class="group-section">
                <app-form-button-group-simple [formSubmitted]="form.submitted"
                    [control]="aboutFg.controls.isVehicleTradeInFinanced" label="Is the vehicle currently financed?">
                </app-form-button-group-simple>
            </div>

            <div class="group-section" *ngIf="aboutFg.controls.isVehicleTradeInFinanced.value == UserAction.Yes">
                <app-form-field-currency [formSubmitted]="form.submitted" label="Balance owing"
                    [control]="aboutFg.controls.tradeInVehicle.controls.encumbrance" [decimal_precision]="2">
                </app-form-field-currency>
            </div>

        </ng-container>
    </section>

    <section>
        <div class="group-section info-box">
            <div class="flex-content">
                <span class="mat-body-large">Vehicle cost</span>
                <span class="mat-body-large">{{ aboutFg.get('loanAmount')?.value ?
                    (aboutFg.get('loanAmount')?.value
                    | currency) : '$0.00' }}</span>
            </div>
            <div class="flex-content">
                <span class="mat-body-large">Other items</span>
                <span class="mat-body-large">{{otherItems() | currency}}</span>
            </div>
            <div class="flex-content">
                <span class="mat-body-large"><span class="italic-text">Less</span> cash deposit</span>
                <span class="mat-body-large">{{ aboutFg.get('depositAmount')?.value ?
                    ''+(aboutFg.get('depositAmount')?.value | currency) : '$0.00' }}</span>
            </div>
            <div class="flex-content">
                <span class="mat-body-large"><span class="italic-text">Less</span> net trade in value <mat-icon
                        class="info-tooltip" svgIcon="info"
                        matTooltip="Estimated value of your trade in vehicle less any finance you currently owe on it"></mat-icon></span>
                <span class="mat-body-large">{{ netTradeIn() > 0 ? '' + (netTradeIn() | currency) : (netTradeIn() |
                    currency) }}</span>

            </div>
            <hr class="separator no-margin" />
            <div class="flex-content text-end stacked-text hide-for-large">
                <span class="mat-title-medium black-font">Total amount to borrow</span>
                <span class="mat-headline-large">{{loanTotal() | currency}}</span>
                <span class="mat-body-small black-font no-letterspace">Excludes any applicable loan related fees</span>
                <mat-error *ngIf="aboutFg.controls.netLoanAmount.errors?.['rangeError']" style="margin-top: 8px;">{{
                    aboutFg.controls.netLoanAmount.errors?.['rangeError']?.message }}</mat-error>
            </div>
            <div class="flex-content show-for-large">
                <div>
                    <div class="mat-title-medium black-font">Total amount to borrow</div>
                    <div class="mat-body-small black-font no-letterspace">Excludes any applicable loan related fees
                    </div>
                </div>
                <div>
                    <span class="mat-headline-large">{{loanTotal() | currency}}</span>

                </div>

            </div>

            <div class="show-for-large">
                <mat-error *ngIf="aboutFg.controls.netLoanAmount.errors?.['rangeError']">{{
                    aboutFg.controls.netLoanAmount.errors?.['rangeError']?.message }}</mat-error>
            </div>
        </div>

    </section>

    <hr class="separator" />
    <section>
        <div class="group-section">
            <h1 class="mat-headline-large">Loan details</h1>
        </div>

        <div class="group-section small-group">
            <p class="mat-body-large">What is your preferred loan term (in months)?</p>
            <div class="group-required">
                <mat-button-toggle-group class="button-group" aria-label="What is your preferred loan term (in months)?"
                    [formControl]="aboutFg.controls.preferredLoanTerm" [hideSingleSelectionIndicator]="true">
                    <mat-button-toggle [value]="12">12</mat-button-toggle>
                    <mat-button-toggle [value]="24">24</mat-button-toggle>
                    <mat-button-toggle [value]="36">36</mat-button-toggle>
                    <mat-button-toggle [value]="48">48</mat-button-toggle>
                    <mat-button-toggle [value]="60">60</mat-button-toggle>
                    <mat-button-toggle [value]="72">72</mat-button-toggle>
                    <mat-button-toggle [value]="84">84</mat-button-toggle>
                </mat-button-toggle-group>
                <mat-error *ngIf="form.submitted && aboutFg.controls.preferredLoanTerm.hasError('required')">
                    Please select a loan term.
                </mat-error>
            </div>
        </div>

        <div class="group-section small-group">
            <p class="mat-body-large section-title">
                How often would you like to make your loan repayments?
                <span class="mat-body-large section-subtitle">This usually aligns with your primary income payment
                    frequency</span>
            </p>

            <div class="group-required">
                <mat-button-toggle-group class="button-group"
                    aria-label="How often would you like to make your loan repayments?"
                    [formControl]="aboutFg.controls.repaymentFrequency" [hideSingleSelectionIndicator]="true">
                    <mat-button-toggle
                        value="{{LoanInformationBaseRequestPeriodTypeEnum.Weekly}}">Weekly</mat-button-toggle>
                    <mat-button-toggle
                        value="{{LoanInformationBaseRequestPeriodTypeEnum.Fortnightly}}">Fortnightly</mat-button-toggle>
                    <mat-button-toggle
                        value="{{LoanInformationBaseRequestPeriodTypeEnum.Monthly}}">Monthly</mat-button-toggle>
                </mat-button-toggle-group>
                <mat-error *ngIf="form.submitted && aboutFg.controls.repaymentFrequency.hasError('required')">
                    Please select how often you'd like to make repayments.
                </mat-error>
            </div>
        </div>

        <div class="section-next">
            <button class="btn-next" mat-flat-button (click)="onButtonNext(aboutFg, parentStepper)">Next</button>

        </div>
    </section>

    <section>
        
    </section>
</form>